type TrafficLightState = "red" | "yellow" | "green";

const useAnswerProgress = () => {
    const normalizeCount = (value: unknown): number => {
        return Math.max(0, +(value ?? 0));
    };

    const getTotalCount = (totalQuestionsCount: unknown): number => {
        return normalizeCount(totalQuestionsCount);
    };

    const getAnsweredCount = (answeredCount: unknown, totalQuestionsCount: unknown): number => {
        const total = getTotalCount(totalQuestionsCount);

        return Math.min(total, normalizeCount(answeredCount));
    };

    const getTrafficLightState = (answeredCount: unknown, totalQuestionsCount: unknown): TrafficLightState => {
        const total = getTotalCount(totalQuestionsCount);
        const answered = getAnsweredCount(answeredCount, total);

        if (!total) {
            return "green";
        }

        if (!answered) {
            return "red";
        }

        if (answered >= total) {
            return "green";
        }

        return "yellow";
    };

    const getTrafficTextClass = (answeredCount: unknown, totalQuestionsCount: unknown): string => {
        return {
            red: "text-red-600",
            yellow: "text-amber-600",
            green: "text-green-600",
        }[getTrafficLightState(answeredCount, totalQuestionsCount)];
    };

    const getTrafficBorderClass = (answeredCount: unknown, totalQuestionsCount: unknown): string => {
        return {
            red: "border-red-600",
            yellow: "border-amber-600",
            green: "border-green-600",
        }[getTrafficLightState(answeredCount, totalQuestionsCount)];
    };

    const getTrafficBadgeClass = (answeredCount: unknown, totalQuestionsCount: unknown): string => {
        return {
            red: "bg-red-600 text-white",
            yellow: "bg-amber-600 text-white",
            green: "bg-green-600 text-white",
        }[getTrafficLightState(answeredCount, totalQuestionsCount)];
    };

    return {
        getTotalCount,
        getAnsweredCount,
        getTrafficLightState,
        getTrafficTextClass,
        getTrafficBorderClass,
        getTrafficBadgeClass,
    };
};

export default useAnswerProgress;
